import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import BarcodeList from "../../components/into-warehouse/barcode-list/barcode-list";
import BuyFactorDetail from "../../components/into-warehouse/buy-factor-detail/buy-factor-detail";
import BuyFactorList from "../../components/into-warehouse/buy-factor-list/buy-factor-list";
import Navigation from "../../components/global/navigation/navigation";
import TopHeader from "../../components/global/navigation/top-header";
import Home from "./pages/home/home";
import Profile from "./pages/profile/profile";
import Search from "./pages/search/search";
import SaleFactorsList from "../../components/out-warehouse-with-factor/sale-factors-list/sale-factors-list";
import SaleFactorDetail from "../../components/out-warehouse-with-factor/sale-factor-detail/sale-factor-detail";

const useStyles = makeStyles({
  mainContent: {
    minHeight: "calc(100vh - 94px)",
    background: "#F4F4F8",
    position: "relative",
    paddingBottom: "2rem",
  },
});

export default function Panel() {
  const classes = useStyles();

  return (
    <>
      <Router>
        <TopHeader />
        <Box className={classes.mainContent}>
          <Switch>
            <Route exact path="/" component={Home}></Route>
            <Route path="/profile" component={Profile}></Route>
            <Route path="/search" component={Search}></Route>
            <Route
              path="/panel/buy-factor-list"
              component={BuyFactorList}
            ></Route>
            <Route
              path="/panel/buy-factor-detail/:id"
              component={BuyFactorDetail}
            ></Route>
            <Route
              path="/panel/barcode-list/:id/:pd_id"
              component={BarcodeList}
            ></Route>
            <Route
              path="/panel/out-warehouse-with-factor"
              component={SaleFactorsList}
            ></Route>
            <Route
              path="/panel/out-with-factor-detail/:id"
              component={SaleFactorDetail}
            ></Route>
          </Switch>
        </Box>
        <Navigation />
      </Router>
    </>
  );
}
